import {TypeEvenement} from '../../shared/models/type-evenement.model';
import {CodeDesignation} from '@sigale-angular/src/models/codeDesignation.model';

export class EvenementPlanning {
	dateEvenement: Date;
	typeEvenement: TypeEvenement;
	dureeEvenement: CodeDesignation;
	prenomNomUtilisateur: string;
	site?: string;

	constructor(
		typeEvenement: TypeEvenement,
		dateEvenement: Date,
		dureeEvenement: CodeDesignation,
		prenomNomUtilisateur: string,
		site?: string) {
		this.typeEvenement = typeEvenement;
		this.dateEvenement = dateEvenement;
		this.dureeEvenement = dureeEvenement;
		this.prenomNomUtilisateur = prenomNomUtilisateur;
		this.site = site;
	}

	siteAAfficher() {
		return this.site != null ? this.site : '';
	}
}
